export enum ExternalCalendarDateRange {
  FORM_FROM = 'FormFrom',
  FORM_TO = 'FormTo',
  DELIVERY_FROM = 'DeliveryFrom',
  DELIVERY_TO = 'DeliveryTo',
  NONE = 'None',
}
